export const baseURL = "https://roulettecasino.nawarliveapp.top/";
export const adminBaseURL = "https://portal.nawarliveapp.top/";
export const key = "AauCc3J0rXzqlqJvJkLMzg";
